import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL + "ig/";

export const closeIGMessage = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}closeigmessage`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API closeIGMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getIGChatInfo = async (chatListID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getigchatinfo?chatlistid=${chatListID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getIGChatInfo: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getMessageHistory = async (chatListID, IGID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getmessagehistory?chatlistid=${chatListID}&igid=${IGID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getMessageHistory: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getMessageList = async (chatListID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getMessageList?chatlistid=${chatListID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getMessageList: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const IGManualAssignAgent = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}manualassignagent`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API IGManualAssignAgent: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const sendIGMessage = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}sendigmessage`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API sendIGMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const updateAgentRead = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}updateagentread`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API updateAgentRead: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};
